import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import jwtAuthAxios, {setTokenManual} from "../../services/jwtAuth";

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	user: [],
	token: localStorage.getItem(AUTH_TOKEN) || null
}
export const login = createAsyncThunk(
	'posts/getPosts',
	async (thunkAPI) => {
		const res = await fetch('be/api/v1/auth/authenticate').then(
			(data) => data.json()
		)
		return res
})
	
export const signIn =
	createAsyncThunk('auth/signIn',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		let loginCreds = {email, password};
		const authResponse = await jwtAuthAxios.post('/v1/auth/authenticate', loginCreds);
		if (authResponse.data) {
			console.log('authResponse : ',{authResponse})
			const token = authResponse.data.token.access_token;
			const roles = authResponse.data.roles;
			const id_prodi = authResponse.data.token.id_prodi;
			const id = authResponse.data.token.id;
			const nim = authResponse.data.token.nim;
			const angkatan = authResponse.data.token.angkatan;

			localStorage.setItem(AUTH_TOKEN, token);
			localStorage.setItem('roles', roles);
			localStorage.setItem('id_prodi', id_prodi);
			localStorage.setItem('id', id);
			localStorage.setItem('nim', nim);
			localStorage.setItem('angkatan', angkatan);

			setTokenManual(token);

			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const userResponse = await jwtAuthAxios.get('/v1/users/me');
			if (userResponse.data) {
				localStorage.setItem('user_id', userResponse.data.user.user_id);
				localStorage.setItem('name', userResponse.data.user.name);
				localStorage.setItem('username', userResponse.data.user.username);
				return { token, user: userResponse.data };
			} else {
				return rejectWithValue('Not Authorize');
			}
		} else {
			return rejectWithValue('Not Authorize');
		}
	} catch (err) {
		return rejectWithValue('Not Authorize');
	}
})

export const signInTest =
	createAsyncThunk('auth/signIn',async (data, { rejectWithValue }) => {
		const { email, password } = data
		try {
			//const response = await FirebaseService.signInEmailRequest(email, password)
			let loginCreds = {email, password};
			const {data} = await jwtAuthAxios.post('/auth/login', loginCreds);
			const response = {user : "", data : {}}
			if (response.token) {
				const token = response.token.refreshToken;
				localStorage.setItem(AUTH_TOKEN, response.user.access_token);
				return token;
			} else {
				return rejectWithValue(response.message?.replace('Firebase: ', ''));
			}
		} catch (err) {
			return rejectWithValue(err.message || 'Error')
		}
	})

// Key localStorage yang menyimpan konteks user yang sedang login.
const IMPERSONATE_CONTEXT_KEYS = [
	AUTH_TOKEN,
	'roles',
	'id_prodi',
	'prodi_id',
	'id',
	'nim',
	'angkatan',
	'user_id',
	'name',
	'username',
	'registration_id',
	'camaba_id'
];

// Admin login impersonate menjadi user dengan role MAHASISWA, DOSEN, atau ADMIN_PRODI.
export const impersonateUser = createAsyncThunk('auth/impersonate', async (userId, { rejectWithValue }) => {
	try {
		const adminToken = localStorage.getItem(AUTH_TOKEN);
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + adminToken;
		const authResponse = await jwtAuthAxios.post(`/v1/users/impersonate/${userId}`);
		if (!authResponse.data || !authResponse.data.result || !authResponse.data.token) {
			return rejectWithValue('Gagal impersonate');
		}

		// Simpan konteks admin agar bisa dikembalikan saat keluar dari impersonate.
		const backup = {};
		IMPERSONATE_CONTEXT_KEYS.forEach((k) => { backup[k] = localStorage.getItem(k); });
		localStorage.setItem('impersonator_backup', JSON.stringify(backup));
		localStorage.setItem('impersonator_name', localStorage.getItem('name') || localStorage.getItem('username') || 'Admin');
		localStorage.setItem('is_impersonating', 'true');

		// Ganti konteks ke user target (mahasiswa).
		const token = authResponse.data.token.access_token;
		const roles = authResponse.data.roles;
		const id_prodi = authResponse.data.token.id_prodi;
		const id = authResponse.data.token.id;
		const nim = authResponse.data.token.nim;
		const angkatan = authResponse.data.token.angkatan;

		localStorage.setItem(AUTH_TOKEN, token);
		localStorage.setItem('roles', roles);
		localStorage.setItem('id_prodi', id_prodi);
		localStorage.setItem('id', id);
		localStorage.setItem('nim', nim);
		localStorage.setItem('angkatan', angkatan);

		setTokenManual(token);
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

		const userResponse = await jwtAuthAxios.get('/v1/users/me');
		if (userResponse.data) {
			localStorage.setItem('user_id', userResponse.data.user.user_id);
			localStorage.setItem('name', userResponse.data.user.name);
			localStorage.setItem('username', userResponse.data.user.username);
		}
		return { token };
	} catch (err) {
		return rejectWithValue('Gagal impersonate');
	}
});

// Keluar dari impersonate dan kembali ke konteks admin semula.
export const stopImpersonate = createAsyncThunk('auth/stopImpersonate', async () => {
	const backupRaw = localStorage.getItem('impersonator_backup');
	if (backupRaw) {
		const backup = JSON.parse(backupRaw);
		Object.keys(backup).forEach((k) => {
			if (backup[k] === null || backup[k] === undefined) {
				localStorage.removeItem(k);
			} else {
				localStorage.setItem(k, backup[k]);
			}
		});
		const adminToken = backup[AUTH_TOKEN];
		setTokenManual(adminToken);
		jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + adminToken;
	}
	localStorage.removeItem('impersonator_backup');
	localStorage.removeItem('impersonator_name');
	localStorage.removeItem('is_impersonating');
	return true;
});

export const signUp = createAsyncThunk('auth/signUp',async (data, { rejectWithValue }) => {
	const { email, password } = data
	try {
		const response = await FirebaseService.signUpEmailRequest(email, password)
		if (response.user) {
			const token = response.user.refreshToken;
			localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
			return token;
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
})

export const signOut = createAsyncThunk('auth/signOut',async () => {
    const response = await FirebaseService.signOutRequest()
	localStorage.removeItem(AUTH_TOKEN);
	localStorage.removeItem("roles");
	localStorage.removeItem("id_prodi");
	localStorage.removeItem("prodi_id");
	localStorage.removeItem("id");
	localStorage.removeItem("nim");
	localStorage.removeItem("angkatan");
	localStorage.removeItem("user_id");
	localStorage.removeItem("registration_id");
	localStorage.removeItem("camaba_id");
	localStorage.removeItem("username");
	localStorage.removeItem("name");
	localStorage.removeItem("persist:root");
	localStorage.removeItem("impersonator_backup");
	localStorage.removeItem("impersonator_name");
	localStorage.removeItem("is_impersonating");
    return response.data
})

export const signInWithGoogle = createAsyncThunk('auth/signInWithGoogle', async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInGoogleRequest()
	if (response.user) {
		const token = response.user.refreshToken;
		localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
		return token;
	} else {
		return rejectWithValue(response.message?.replace('Firebase: ', ''));
	}
})

export const signInWithFacebook = createAsyncThunk('auth/signInWithFacebook', async (_, { rejectWithValue }) => {
    const response = await FirebaseService.signInFacebookRequest()
	if (response.user) {
		const token = response.user.refreshToken;
		localStorage.setItem(AUTH_TOKEN, response.user.refreshToken);
		return token;
	} else {
		return rejectWithValue(response.message?.replace('Firebase: ', ''));
	}
})


export const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			state.loading = false
			state.redirect = '/'
			state.token = action.payload
		},
		showAuthMessage: (state, action) => {
			state.message = action.payload
			state.showMessage = true
			state.loading = false
		},
		hideAuthMessage: (state) => {
			state.message = ''
			state.showMessage = false
		},
		signOutSuccess: (state) => {
			state.loading = false
			state.token = null
			state.redirect = '/'
		},
		showLoading: (state) => {
			state.loading = true
		},
		signInSuccess: (state, action) => {
			state.loading = false
			state.token = action.payload
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(signIn.pending, (state) => {
				state.loading = true
			})
			.addCase(signIn.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signIn.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signOut.fulfilled, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signOut.rejected, (state) => {
				state.loading = false
				state.token = null
				state.redirect = '/'
			})
			.addCase(signUp.pending, (state) => {
				state.loading = true
			})
			.addCase(signUp.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signUp.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithGoogle.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithGoogle.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithGoogle.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
			.addCase(signInWithFacebook.pending, (state) => {
				state.loading = true
			})
			.addCase(signInWithFacebook.fulfilled, (state, action) => {
				state.loading = false
				state.redirect = '/'
				state.token = action.payload
			})
			.addCase(signInWithFacebook.rejected, (state, action) => {
				state.message = action.payload
				state.showMessage = true
				state.loading = false
			})
	},
})

export const { 
	authenticated,
	showAuthMessage,
	hideAuthMessage,
	signOutSuccess,
	showLoading,
	signInSuccess
} = authSlice.actions

export default authSlice.reducer
